// src/utils/arrangementAlgorithms.js
export function arrangeSnakeAlgorithm(
    arrangedCargos,
    cargos,
    cargoArea,
    arrangeParameters
) {
  // Input validation
  if (!cargoArea || cargoArea.length === 0) {
    throw new Error('Cargo area is not defined');
  }

  if (!arrangedCargos || !cargos || !arrangeParameters) {
    throw new Error('Missing required parameters');
  }

  const createCuboidData = (cargos) => {
    return cargos.map((cargo) => ({
      '#11_uuid': cargo.uuid,
      '#12_width_X': parseInt(cargo.widthX),
      '#13_height_Y': parseInt(cargo.heightY),
      '#14_length_Z': parseInt(cargo.depthZ),
      '#15_position_x': parseInt(cargo.x),
      '#16_position_y': parseInt(cargo.y),
      '#17_position_z': parseInt(cargo.z),
      '#18_color': cargo.userColor || '#3b82f6',
    }));
  };

  // Create JSON payload
  const payload = {
    '#00_access_token': null,
    '#01_start_corner': parseInt(arrangeParameters.startCorner),
    '#02_row_arrangement': arrangeParameters.rowDirection,
    '#03_arrangement_direction': arrangeParameters.arrangementDirection,
    '#04_arrangement_option': arrangeParameters.arrangementOptions,
    '#11_uuid': cargoArea[0].uuid,
    '#12_width_X': parseInt(cargoArea[0].widthX),
    '#13_height_Y': parseInt(cargoArea[0].heightY),
    '#14_length_Z': parseInt(cargoArea[0].depthZ),
    '#15_position_x': 0,
    '#16_position_y': 0,
    '#17_position_z': 0,
    '#200_arranged_cuboids': createCuboidData(arrangedCargos),
    '#300_not_linked_cuboids': createCuboidData(cargos),
  };

  console.log('Sending snake algorithm request:', payload);

  const sendDataToPort = async (payload) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${API_URL}/api/ca/snake_algorithm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`${errorText}`);
      }

      const result = await response.json();
      console.log('Data sent successfully:', result);
      
      return result['#200_arranged_cuboids'] || [];
      
    } catch (error) {
      throw error;
    }
  };

  return sendDataToPort(payload);
}

